<template>
  <!-- eslint-disable-next-line vue/no-unused-refs -->
  <base-list-management ref="baseListManagement"
    :configData.sync="configData"
    >
    <PublicExport
      slot="custom-export"
      v-if="judgePermission('driver_customer_list_detail')"
      exportTitle="导出"
      exportTemplate="LeaseOrder"
      :getSearchData="searchParams"
      templateCode="vehicle-workbench-ent-rent-order"
      :getSearchCondition="getSearchCondition"
    />
  </base-list-management>
</template>

<script>
import diffConfigFn from './config'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  name: 'enterpriseOrder',
  props: ['customerId', 'customerType', 'customerData'],
  data() {
    const { configData } = diffConfigFn.call(this)
    return {
      configData,
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    dealWithData(params) {
      if (params.startTime && params.startTime.length) {
        const [start, end] = params.startTime
        params.createStartTime = start
        params.createEndTime = end
      }
      params.customerId = this.customerId
      params.customerType = Number(this.customerType)
      return params
    },
    searchParams() {
      return this.$refs.baseListManagement?.getParams() || {}
    },
    getSearchCondition() {
      const params = this.searchParams()
      const conditions = this.configData.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        const val = params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      conditions.push({
        label: '客户名称',
        key: 'customerId',
        matchValue: this.customerData.customerName,
        hidden: false,
      })
      return conditions
    },
  },
}
</script>
